/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const createPolicyContext = React.createContext({});
export let createPolicyMachine: any;

const MODULE_NAME = 'machines.createPolicy';

export const useSMcreatePolicy = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  createPolicyMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(createPolicyMachine);

  return {
    createPolicyMachine,
    createPolicyState: state,
    createPolicySend: send,
  };
};
